import { render, staticRenderFns } from "./emailgenerate.vue?vue&type=template&id=33052f1a&scoped=true&"
import script from "./emailgenerate.vue?vue&type=script&lang=js&"
export * from "./emailgenerate.vue?vue&type=script&lang=js&"
import style0 from "./emailgenerate.vue?vue&type=style&index=0&id=33052f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33052f1a",
  null
  
)

export default component.exports